export const contractCancellation = {
  'Contract cancellation': 'Seguimiento de la cancelación',
  'Track the progress of your contract cancellation request':
    'Sigue el progreso de tu solicitud de cancelación de contrato',
  'Contract nº {{code}}': 'Contrato nº {{code}}',
  'Requested on {{date}}': 'Solicitado el {{date}}',
  'Signature deadline: {{date}}': 'Plazo para la firma: {{date}}',
  'Sign term now': 'Firmar el término ahora',
  'Request again': 'Solicitar nuevamente',
  'Request new link': 'Solicitar nuevo enlace',
  'Your cancellation goes back to our team for review, and we will send you a new signature link by e-mail. Do you want to continue?':
    'Tu cancelación vuelve al análisis de nuestro equipo, que te enviará un nuevo enlace de firma por correo electrónico. ¿Deseas continuar?',
  'Not now': 'Ahora no',
  'Yes, request': 'Sí, solicitar',
  'Request received! Our team will review your cancellation and send you a new signature link by e-mail.':
    '¡Solicitud recibida! Nuestro equipo analizará tu cancelación y te enviará un nuevo enlace de firma por correo electrónico.',
  'Sent communications': 'Comunicaciones enviadas',
  'No communications sent so far.':
    'Ninguna comunicación enviada hasta el momento.',
  'It was not possible to load the communications.':
    'No fue posible cargar las comunicaciones.',
  "You don't have a cancellation in progress.":
    'No tienes una cancelación en curso.',
  'It was not possible to load the cancellation tracking.':
    'No fue posible cargar el seguimiento de la cancelación.',
};
